<template>
  <div>
    <Loading v-if="authStatus.isRunning" />
    <LoggedIn v-if="isAuthenticated"/>
    <div v-else class="section__login section__form">
      <p class='text--bold'>Log in</p>
      <LoginForm />
      <div class="btn__group">
        <AuthWithGoogle />
        <AuthWithApple />
        <AuthWithFacebook />
      </div>
      <FooterInfo :isSignup="false"/>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/elements/Loading';
import ThirdPartyAuthInit from '@/helpers/ThirdPartyAuthInit';
import LoggedIn from '@/components/LoggedIn';
import LoginForm from '@/components/authentication/LoginForm';
import AuthWithFacebook from '@/components/authentication/AuthWithFacebook';
import AuthWithGoogle from '@/components/authentication/AuthWithGoogle';
import AuthWithApple from '@/components/authentication/AuthWithApple';
import FooterInfo from '@/components//elements/FooterInfo';
import { writeCookie } from '@/helpers/helpers';
import { capture as captureAttribution } from '@/helpers/Attribution';

import { mapGetters } from 'vuex';
import { updateAuthStatus } from '@/helpers/StoreActions';
import { getUrlVars } from '@/helpers/helpersUsingStore';

export default {
  name: "Login",
  components: {
    Loading,
    LoggedIn,
    LoginForm,
    AuthWithFacebook,
    AuthWithGoogle,
    AuthWithApple,
    FooterInfo
  },
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'iFrameParentUrl',
      'authStatus'
    ])
  },
  watch: {
    //apple sign in callback will be kept with Ember
    // async $route(to, from) {
    //   const query = to.query;
    //   const state = get(query, 'state');
    //   const id_token = get(query, 'id_token');

    //   if(state && id_token) {

    //     const res = await authenticateWithAppleToken({
    //       state,
    //       id_token
    //     });

    //     if(res === undefined) {
    //       this.error.template = 'Unexpected error! Please try to log in later.';
    //     } else {
    //       console.log('----- log in with Apple -----');
    //       console.info(res);
    //       this.error.template = '';
    //       if(res.didCreateUser) {
    //         track('signUpApple');
    //         handleAuthSuccessful({res, source: 'apple', isSignUp: true});
    //       } else {
    //         track('logInapple');
    //         handleAuthSuccessful({res, source: 'apple', isSignUp: false});
    //       }
    //     }
    //   } else {
    //     this.error.template = 'Unexpected error! Please try to log in later.';
    //   }
    // }
  },
  created() {
    // PAE-2465: first-touch campaign context from the parent page's URL when framed.
    captureAttribution(this.iFrameParentUrl);
    updateAuthStatus({});
    if(!this.isAuthenticated) {
      ThirdPartyAuthInit();

      if(this.iFrameParentUrl) {
        if(getUrlVars('inviteToken')) {
          writeCookie('inviteToken', getUrlVars('inviteToken'), 1);
        }
      }
    }
  },
}
</script>

<style lang="sass">
  @font-face {
  font-family: 'Urbane Rounded';
  src: url('~@/assets/fonts/UrbaneRounded-Medium.ttf');
  font-weight: 300;
  font-style: normal;
  }

  .section__form * {
    box-sizing: border-box;
  }

  .section__form {
    position: relative;
    font-family: "houschka-rounded", Sans-serif;
    min-height: 400px;

    .form__title {
      margin: 0 auto 15px auto;
    }

    .align--left {
      text-align: left;
    }
  }

  .fade-enter-active {
    transition: opacity 1s;
  }
  .fade-leave-active {
    transition: opacity 0.1s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
